/**
 * INNFLOW Design System — Bottom nav mobile (<1024px)
 * Exibido apenas em lg:hidden. Navegação principal + Menu (abre sidebar).
 */

import { useNavigate, useLocation } from "react-router-dom";
import { LayoutDashboard, MessageSquare, Settings, Menu } from "lucide-react";
import { cn } from "@/lib/utils";
import { useSidebar } from "@/contexts/SidebarContext";
import { useTotalUnreadCount } from "@/hooks/useUnreadCount";

const items = [
  { path: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { path: "/dashboard/conversations", label: "Conversas", icon: MessageSquare },
  { path: "/dashboard/settings", label: "Configurações", icon: Settings },
];

export function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { toggleSidebar } = useSidebar();
  const totalUnread = useTotalUnreadCount();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 lg:hidden flex items-center justify-around h-14 px-2 pb-safe bg-black/80 backdrop-blur-xl border-t border-white/[0.06]"
      role="navigation"
      aria-label="Menu principal"
    >
      <button
        type="button"
        onClick={toggleSidebar}
        className="flex flex-col items-center justify-center gap-0.5 py-2 px-4 text-white/50 hover:text-white/80"
        aria-label="Abrir menu"
      >
        <Menu className="w-6 h-6" />
        <span className="text-[10px]">Menu</span>
      </button>

      {items.map((item) => {
        const isActive = location.pathname === item.path;
        const Icon = item.icon;
        const showBadge =
          item.path === "/dashboard/conversations" && totalUnread > 0;

        return (
          <button
            key={item.path}
            type="button"
            onClick={() => navigate(item.path)}
            className={cn(
              "flex flex-col items-center justify-center gap-0.5 py-2 px-4 transition-colors",
              isActive ? "text-[#19F58C]" : "text-white/50 hover:text-white/80",
            )}
            aria-label={item.label}
            aria-current={isActive ? "page" : undefined}
          >
            <span className="relative">
              <Icon className="w-6 h-6" />
              {showBadge && (
                <span className="absolute -top-1 -right-1 min-w-[14px] h-[14px] rounded-full bg-[#19F58C] text-[#000000] text-[9px] font-bold flex items-center justify-center px-0.5">
                  {totalUnread > 99 ? "99+" : totalUnread}
                </span>
              )}
            </span>
            <span className="text-[10px]">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
